<template>
  <div>
    <div class="flex flex-col space-y-2 animate-pulse" v-if="loading">
      <div
        class="bg-white px-2 py-2 rounded-md border shadow-sm"
        v-for="n in 5"
        :key="n"
      >
        <div class="relative flex items-start">
          <div class="flex h-6 items-center">
            <input
              type="checkbox"
              class="
                h-4
                w-4
                rounded
                border-gray-300
                text-cyan-600
                focus:ring-cyan-600
              "
              disabled
            />
          </div>
          <div class="ml-3 text-base leading-6">
            <div class="h-6 w-40 bg-gray-300 rounded" />
            <div class="h-6 w-72 bg-gray-200 rounded mt-2" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col space-y-2" v-else>
      <div
        class="bg-white px-2 py-2 rounded-md border shadow-sm"
        v-for="company in companies"
        :key="company.company_uuid"
      >
        <div class="relative flex items-start">
          <div class="flex h-6 items-center">
            <input
              id="comments"
              aria-describedby="comments-description"
              name="comments"
              type="checkbox"
              class="
                h-4
                w-4
                rounded
                border-gray-300
                text-cyan-600
                focus:ring-cyan-600
              "
              @input="updateValue($event, company)"
            />
          </div>
          <div class="ml-3 text-base leading-6">
            <label for="comments" class="font-medium text-gray-900">
              {{ company.title_th }}
            </label>
            <p id="comments-description" class="text-gray-500">
              {{ company.company_code }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    companies: {
      type: Array,
      required: true,
    },
  },

  methods: {
    updateValue(event, company) {
      this.$emit('selectedCompany', { checked: event.target.checked, company })
    },
  },
}
</script>
